// Public URL a customer (or a tester) can open to start a chat with an inbox.
// Chatwoot does not show one, so it is derived from the channel's own identifier.

const PLAYGROUND_FLAG = 'ai_bot_playground';

export const isAiBotPlaygroundInbox = inbox =>
  Boolean(inbox?.additional_attributes?.[PLAYGROUND_FLAG]);

const digitsOnly = value => String(value || '').replace(/\D/g, '');

export const inboxPublicLink = (inbox, origin = window.location.origin) => {
  if (!inbox) return null;
  switch (inbox.channel_type) {
    case 'Channel::WebWidget':
      return inbox.website_token
        ? `${origin}/widget?website_token=${inbox.website_token}`
        : null;
    case 'Channel::Telegram':
      return inbox.bot_name ? `https://t.me/${inbox.bot_name}` : null;
    case 'Channel::Whatsapp':
      return digitsOnly(inbox.phone_number)
        ? `https://wa.me/${digitsOnly(inbox.phone_number)}`
        : null;
    case 'Channel::FacebookPage':
      return inbox.page_id ? `https://m.me/${inbox.page_id}` : null;
    case 'Channel::Email':
      return inbox.email ? `mailto:${inbox.email}` : null;
    default:
      return null;
  }
};
